import { InjectionToken } from "@angular/core";

export interface DataExportModuleConfig {
	production: boolean;
	url: string;
	/** Base URL of the portal backend (Nest API). Falls back to `url` when unset. */
	portalBackendUrl?: string;
	demo: boolean;
}
export const EXPORT_CONFIG = new InjectionToken<DataExportModuleConfig>("EXPORT_CONFIG");
